var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 700 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 53L9.7 51.5C19.3 50 38.7 47 58.2 43C77.7 39 97.3 34 116.8 37.2C136.3 40.3 155.7 51.7 175 54C194.3 56.3 213.7 49.7 233.2 46.7C252.7 43.7 272.3 44.3 291.8 49C311.3 53.7 330.7 62.3 350 61C369.3 59.7 388.7 48.3 408.2 43C427.7 37.7 447.3 38.3 466.8 42.5C486.3 46.7 505.7 54.3 525 55.2C544.3 56 563.7 50 583.2 49.5C602.7 49 622.3 54 641.8 50.8C661.3 47.7 680.7 36.3 690.3 30.7L700 25L700 101L690.3 101C680.7 101 661.3 101 641.8 101C622.3 101 602.7 101 583.2 101C563.7 101 544.3 101 525 101C505.7 101 486.3 101 466.8 101C447.3 101 427.7 101 408.2 101C388.7 101 369.3 101 350 101C330.7 101 311.3 101 291.8 101C272.3 101 252.7 101 233.2 101C213.7 101 194.3 101 175 101C155.7 101 136.3 101 116.8 101C97.3 101 77.7 101 58.2 101C38.7 101 19.3 101 9.7 101L0 101Z",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.8580d36c8729e19461226f0ce93a8ee9.svg";
export { ForwardRef as ReactComponent };